import React, { useEffect, useState } from 'react';
import { MainContainer } from '../../components/template/MainContainer';
import Preloader from '../../components/template/Preloader';
import CabecalhoBotao from './CabecalhoBotao';
import { fetchData } from '../../utils/datasource';
import { useAuth } from '../../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';

export default () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuth();
  const currentLocation = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetchDataFromAPI = async () => {
      try {
        setLoading(true);

        const response = await fetchData(`/DCAPROVPC/api/dc/getcabpc?IDUSR=${user?.id || 'Usuário não encontrado'}`, 'GET');
        const result = await response.json();        

        setData(result.PEDIDO);
      } catch (err) {
        setError('Erro ao carregar os dados.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDataFromAPI();
  }, [currentLocation.pathname])

  if (loading) return <Preloader />

  if (error) {
    navigate('/'); // Redireciona para a página inicial
    return null; // Evita renderização desnecessária
  }

  return (
    <MainContainer headerData={{ title: `Pedido de Compras`, subtitle: `Aprovação` }}>
      {data.map((item, index) => (
        <CabecalhoBotao key={index} data={item} />

      ))}
    </MainContainer>
  );
};
